import TagManager from 'react-gtm-module';
import Config from 'arbitrip-common/client/utils/Config';
import moment from 'moment';

export function startSession(profile) {
    if (!profile) return;
    if (!Config.gtmId) throw Error('GTM ID is not defined');

    const tagManagerArgs = {
        gtmId: Config.gtmId,
    };

    TagManager.initialize(tagManagerArgs);

    // Initialize additional container for specific domain
    const gtmId = Config.additionalGTMperDomain.get(window.location.hostname);

    if (gtmId) {
        const additionalTagManagerArgs = {
            gtmId,
        };
        TagManager.initialize(additionalTagManagerArgs);
    }
}

export function trackEvent(event_name, properties, callback) {
    properties = fixFormats(properties);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event_name,
        ...properties,
    });

    if (typeof callback === 'function') callback();
}

export function endSession(profile) {
    return undefined;
}

function fixFormats(data) {
    let payload = {};
    for (const prop in data) {
        let value = data[prop];
        ///
        /// convert date to window.mixpanel date format
        ///
        if ((value instanceof Date || value instanceof moment) && moment(value).isValid(value)) {
            value = moment.utc(moment(value).format('YYYY-MM-DD')).toISOString().split('.')[0];
        }
        payload[prop] = value;
    }
    return payload;
}
